/**
 * 📊 Reports Hub — página principal del módulo de reportes
 * Ruta: /apps/reports
 */

import {
  Page,
  Card,
  BlockStack,
  InlineStack,
  Text,
  InlineGrid,
  Box,
  Icon,
} from '@/lib/polaris';
import {
  ChartVerticalFilledIcon,
  ChartLineIcon,
} from '@/lib/polaris-icons';
import { ROUTES } from '@/config/routes.config';
import { useStoreNavigate } from '@/hooks/useStoreNavigate';

const SECTIONS = [
  {
    title: 'Dashboards',
    description: 'Crea dashboards con widgets de KPIs, gráficos y tablas que se actualizan en tiempo real.',
    icon: ChartVerticalFilledIcon,
    route: ROUTES.APPS_REPORTS_DASHBOARDS,
  },
  {
    title: 'Reportes guardados',
    description: 'Consulta datos de cualquier módulo con filtros personalizados. Exporta a CSV.',
    icon: ChartLineIcon,
    route: ROUTES.APPS_REPORTS_SAVED,
  },
];

export default function ReportsHubPage() {
  const storeNavigate = useStoreNavigate();

  return (
    <Page title="Reportes y Analytics">
      <InlineGrid columns={{ xs: 1, sm: 2 }} gap="400">
        {SECTIONS.map((section) => (
          <div key={section.title} onClick={() => storeNavigate(section.route)} style={{ cursor: 'pointer' }}>
            <Card>
              <BlockStack gap="300">
                <InlineStack gap="200" blockAlign="center">
                  <Icon source={section.icon} />
                  <Text as="h2" variant="headingMd">{section.title}</Text>
                </InlineStack>
                <Text as="p" tone="subdued">{section.description}</Text>
              </BlockStack>
            </Card>
          </div>
        ))}
      </InlineGrid>
    </Page>
  );
}
